<template>
  <div class="container p-0" v-show="!hidden">
    <div class="input-group has-validation">
      <input :ref="'inputField_'+element.name" :value="emailValue" @input="elementChanged" @blur="elementChanged" :type="element.type" :id="ids.input"
        :name="element.name" :autocomplete="element.autocomplete || 'email'" class="form-control" :placeholder="getTextFor(element.placeholder,lang)" 
        :required="element.required" :aria-describedby="describedBy" :aria-invalid="ariaInvalid" :disabled="hidden">
    </div>
    <div class="invalid-feedback" :id="ids.error" :style="invalidStyle">{{getTextFor(element.invalid, lang)}}</div>
    <div v-if="heeftUitleg" :id="ids.help" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
  </div>
</template>

<script>
import veldToegankelijkheid from '../../utils/veldToegankelijkheid'

export default {
  mixins: [veldToegankelijkheid],
  name: 'FormElementEmailInput',
  props: ['element', 'lang', 'targetId', 'wasValidated', 'valueObj', 'hidden'],
  emits: ['elementChanged'],
  data() {
    return {
      emailValue: '',
    }
  },
  watch: {
    valueObj(obj) {
      if(obj) {
        if(obj.value) {
          this.emailValue = obj.value
        } else {
          this.emailValue = ''
        }
      }
    },
  },
  methods: {
    elementChanged() {
      let data = {value: this.$refs['inputField_'+this.element.name].value}
      if(this.element.confirmationEmail) {
        if(this.element.emailSubject) data.emailSubject = this.element.emailSubject[this.lang];
        if(this.element.template) data.template = this.element.template[this.lang];
        if(this.element.htmlTemplate) data.htmlTemplate = this.element.htmlTemplate[this.lang];
      }
      this.$emit('elementChanged', this.element.name, data)
    },
    checkFieldValidity(fieldRef) {
      const field = this.$refs[fieldRef];
      return field && field.checkValidity();
    },
    getTextFor(data, lang) {
      return data ? data[lang] : '';
    },
  },
  created(){
    if(this.valueObj && this.valueObj.value) {
      this.emailValue = this.valueObj.value
    } 
  }

}
</script>
